import { useNavigate } from 'react-router-dom';
import { ButtonStartOnboarding } from './styleGuide';
import { useAppSelector } from '../../../../hooks/hooksRedux';
import { RootState } from '../../../../store';

export const BtnStartOnboarding = ({ text, onClick, callComponent }: any) => {
  const navigate = useNavigate();
  const { background } = useAppSelector((state: RootState) => state.styleGuide.data);

  const backgroundColor = background.primary;
  const backgroundColorHover = background.hover;

  if (callComponent) navigate('/onboarding');

  return (
    <ButtonStartOnboarding $backgroundColor={backgroundColor} $backgroundHover={backgroundColorHover} onClick={onClick}>
      {text}
    </ButtonStartOnboarding>
  );
};
